import StaticPageList from './static-page-list';

export default StaticPageList;
